import { faChartLine } from '@fortawesome/pro-light-svg-icons'

import { Box, DashboardModule, LineChart } from '@domain-group/suit-theme'

import useChartData from '@hooks/useChartData'

import AnalyticsBlankstateImageUrl from '../../../assets/analytics.svg'

export const icon = faChartLine

export const configOptions = () => ({
  date_period: {
    component: 'select',
    key: 'date_period',
    label: 'Date Period',
    optionKey: 'queryParams',
    values: [
      { key: 'day', label: 'Days' },
      { key: 'week', label: 'Weeks' },
      { key: 'month', label: 'Months' },
      { key: 'year', label: 'Years' },
    ],
  },
  date_range: {
    component: 'select',
    key: 'date_range',
    label: 'Date Range',
    optionKey: 'queryParams',
    values: [
      { key: '3_months', label: '3 Months' },
      { key: '6_months', label: '6 Months' },
      { key: '12_months', label: '1 Year' },
    ],
  },
  title: {
    component: 'input',
    key: 'title',
    label: 'Title',
    optionKey: 'customization',
  },
})

interface TasksCompletedPerDatePeriodChartProps {
  customOptions: {
    customization?: {
      title?: string,
    },
    queryParams?: object,
  },
  editing: boolean,
}

const TasksCompletedPerDatePeriodChart = (props: TasksCompletedPerDatePeriodChartProps) => {
  const { customOptions, editing } = props
  const { queryParams } = customOptions || {}

  const chartDataPayload = useChartData('task_list_items_completed_per_date_period', {
    excludedDataKeys: ['name'],
    requestOptions: queryParams,
  })
  const { dataArray, loading } = chartDataPayload

  const title = customOptions?.customization?.title

  return (
    <DashboardModule
      boxProps={{ marginBottom: 0 }}
      contentBoxProps={{ flexDirection: 'column' }}
      editing={editing}
      loading={loading}
      title={title || 'Tasks Completed Per Date Period'}
    >
      {!dataArray.length && !loading && (
        <DashboardModule.BlankState imageUrl={AnalyticsBlankstateImageUrl}>
          <DashboardModule.BlankState.Title>No Chart Available</DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>Try adjusting your filters.</DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!loading && !!dataArray.length && (
        <Box flexDirection="column" flexWrap="wrap" padding="medium">
          <LineChart dataPayload={chartDataPayload} />
        </Box>
      )}
    </DashboardModule>
  )
}

export default TasksCompletedPerDatePeriodChart
